const scrollbarPostions = {
  END: 'END',
  IN_BETWEEN: 'IN_BETWEEN',
  TOP: 'TOP'
};

export default scrollbarPostions;